
import { useState, useCallback } from 'react';

export const useWordAnimations = () => {
  const [wordAnimations, setWordAnimations] = useState<Record<string, string>>({});

  const triggerAnimation = useCallback((word1: string, word2: string, animation: string) => {
    setWordAnimations({
      [word1]: animation,
      [word2]: animation,
    });
    setTimeout(() => {
      setWordAnimations({});
    }, 600);
  }, []);

  const jumpAnimation = useCallback((word1: string, word2: string) => {
    triggerAnimation(word1, word2, 'jump');
  }, [triggerAnimation]);

  const shakeAnimation = useCallback((word1: string, word2: string) => {
    triggerAnimation(word1, word2, 'shake');
  }, [triggerAnimation]);

  const getAnimation = useCallback((word: string) => {
    return wordAnimations[word];
  }, [wordAnimations]);

  return {
    getAnimation,
    jumpAnimation,
    shakeAnimation,
  };
};
